import { Link } from "gatsby";
import React, { ReactNode } from "react";
import Logo from "../../images/logo.svg";
import "./styles.scss";

interface HeaderProps {
  children?: ReactNode;
}

function Header({ children }: HeaderProps) {
  return (
    <header className="header">
      <div>
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>

        {children}
      </div>
    </header>
  );
}

export { Header };
